<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改销售退货单' : '新增销售退货单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="100px"
        ref="editOrderFormRef"
        :rules="getRules"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="客户" prop="customerId">
          <CustomerSelect
            :value="customer"
            @select="selectCustomer"
          ></CustomerSelect>
        </el-form-item>
        <el-row :gutter="10" v-if="headInfo.customerId">
          <el-col :span="6">
            <el-form-item label="联系人信息" prop="customerId">
              <el-input
                v-model="headInfo.customerName"
                placeholder="请输入联系人姓名"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="10" prop="customerId">
              <el-input
                v-model="headInfo.customerPhoneNumber"
                placeholder="请输入联系方式"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="10" prop="customerId">
              <el-input
                v-model="headInfo.customerAddress"
                placeholder="请输入联系地址"
                :disabled="!orderConfig.editCustomer"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="销售单" prop="relatedSaleOrderHeadId">
          <el-input
            :value="getSelectLabel('SaleOrder')"
            placeholder="请选择需要退货的销售单"
            style="width: 400px"
            readonly
            suffix-icon="el-icon-arrow-right"
            @click.native="toSelectSaleOrderPage"
          ></el-input>
        </el-form-item>

        <el-form-item label="所选商品" prop="totalQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="headInfo.totalQuantity && headInfo.totalQuantity > 0"
            >
              {{ "共 " + headInfo.totalQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择商品</span>
            <span>，总零售价：</span>
            <FmAmount :amount="headInfo.commodityBuyingTotalAmount"></FmAmount>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="toSelectSaleOrderItemPage"
              >选择商品</el-button
            >
          </div>
        </el-form-item>

        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo;
            }
          "
          max-height="500px"
          style="width: 100%"
        >
          <el-table-column
            label="商品图片"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityImage
                :commodity="scope.row.relatedSaleOrderItem.commoditySnapshot"
                :commoditySpec="
                  scope.row.relatedSaleOrderItem.commoditySpecSnapshot
                "
              ></CommodityImage>
            </template>
          </el-table-column>
          <el-table-column
            prop="commoditySnapshot.name"
            label="商品信息"
            min-width="150"
            align="left"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="line-height: 1.3em">
                <span style="font-size: 1.1em">{{
                  scope.row.relatedSaleOrderItem.commoditySnapshot.name
                }}</span
                ><br />
                {{
                  "规格：" +
                  scope.row.relatedSaleOrderItem.commoditySpecSnapshot
                    .specName
                }}<br />
                {{
                  "分类：" +
                  scope.row.relatedSaleOrderItem.commoditySnapshot
                    .commodityCategory.name
                }}<br />
                {{
                  "颜色：" +
                  scope.row.relatedSaleOrderItem.commoditySnapshot.color
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="relatedSaleOrderItem.buyingPrice"
            label="商品零售价"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="scope.row.relatedSaleOrderItem.buyingPrice"
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="退货数量"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityQuantityInputBox
                :key="
                  'itemQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.itemQuantity"
                size="small"
                :max="scope.row.relatedSaleOrderItem.itemQuantity"
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
              ></CommodityQuantityInputBox>
            </template>
          </el-table-column>
          <el-table-column
            prop="unit"
            label="单位"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.relatedSaleOrderItem.commoditySnapshot.unit }}
            </template>
          </el-table-column>
          <el-table-column
            prop="commodityBuyingTotalAmount"
            label="总零售价"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="scope.row.commodityBuyingTotalAmount"
              ></FmAmount>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item label="发货标识" class="fm-mt-10" prop="shippedMark">
          <el-tooltip
            slot="label"
            effect="dark"
            content=""
            placement="top-start"
          >
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">发货标识说明</div>
              发货标识所选商品是否已经发货，选项会影响后续单据流程。<br />
              若已发货则会影响所选商品的已出库数量，后续需要创建入库单将已出库商品入库；<br />
              未发货则会影响所选商品的待出库数量，后续无需为商品进行入库操作，自动扣减待出库数量。
            </div>
            <div>
              <i class="el-icon el-icon-question fm-mr-5"></i>
              <span>发货标识</span>
            </div>
          </el-tooltip>
          <div class="fm-flex">
            <el-switch
              v-model="headInfo.shippedMark"
              :active-color="$jsTool.getColor('success')"
              :inactive-color="$jsTool.getColor('warning')"
            >
            </el-switch>
            <p
              v-fmtype="'success'"
              class="fm-ml-10"
              v-if="headInfo.shippedMark"
            >
              已发货
            </p>
            <span v-fmtype="'warning'" class="fm-ml-10" v-else>未发货</span>
          </div>
        </el-form-item>

        <el-form-item label="收款标识" class="fm-mt-10" prop="collectedMark">
          <el-tooltip
            slot="label"
            effect="dark"
            content=""
            placement="top-start"
          >
            <div slot="content" style="line-height: 1.5em">
              <div style="font-weight: bold">收款标识说明</div>
              发收款标识所选商品是否已经收款，选项会影响后续单据流程。<br />
              若已收款则会影响所选商品的已收款金额，后续需要创建付款单将已收款的商品退款；<br />
              未收款则会影响所选商品的待收款金额，后续无需为商品进行退款操作，自动扣减待收款金额。
            </div>
            <div>
              <i class="el-icon el-icon-question fm-mr-5"></i>
              <span>收款标识</span>
            </div>
          </el-tooltip>
          <div class="fm-flex">
            <el-switch
              v-model="headInfo.collectedMark"
              :active-color="$jsTool.getColor('success')"
              :inactive-color="$jsTool.getColor('warning')"
            >
            </el-switch>
            <p
              v-fmtype="'success'"
              class="fm-ml-10"
              v-if="headInfo.collectedMark"
            >
              已收款
            </p>
            <span v-fmtype="'warning'" class="fm-ml-10" v-else>未收款</span>
          </div>
        </el-form-item>

        <el-form-item label="退款金额" prop="orderAmount">
          <el-input-number
            v-model="headInfo.orderAmount"
            size="small"
            :precision="2"
            :min="0"
            :max="
              typeof headInfo.commodityBuyingTotalAmount == 'string'
                ? Number(headInfo.commodityBuyingTotalAmount)
                : headInfo.commodityBuyingTotalAmount
            "
            :step="1"
            style="width: 180px"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="业务员" prop="saleUserIdList">
          <UserTransfer
            v-model="headInfo.saleUserIdList"
            :userList="saleUserList"
            @addUser="addSaleUser"
            @cancelUser="cancelSaleUser"
          ></UserTransfer>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>

    <SaleOrderSelectDialog
      :show="saleOrderSelectDialogShow"
      :customerId="customer.id"
      from="SaleReturnOrder"
      :selectList="itemList"
      @close="saleOrderSelectDialogShow = false"
      @selectSaleOrder="selectSaleOrder"
      v-if="saleOrderSelectDialogShow"
    >
    </SaleOrderSelectDialog>

    <SaleOrderItemSelectDialog
      :show="saleOrderItemSelectDialogShow"
      from="SaleReturnOrder"
      :customerId="customer.id"
      :saleOrderId="relatedSaleOrderHead.id"
      :selectList="itemList"
      @close="saleOrderItemSelectDialogShow = false"
      @selectSaleOrderItem="selectSaleOrderItem"
      v-if="saleOrderItemSelectDialogShow"
    >
    </SaleOrderItemSelectDialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebSaleReturnOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            Object.assign(this.$data, this.$options.data());
            this.$nextTick(() => {
              this.$refs.editOrderFormRef.clearValidate();
            });
            this.initOrderData();
            this.getOrderConfig();
            this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
            if (this.orderId) {
              setTimeout(async () => {
                await this.getOrderInfo();
                this.$nextTick(() => {
                  this.$refs.editOrderFormRef.clearValidate();
                });
              }, 100);
            }
          }, 100);
        }
      },
      immediate: true,
    },
  },
  computed: {
    getRules() {
      let res = {
        orderDate: this.$ruleUtil.simple({
          fieldName: "单据日期",
          handleType: "选择",
          required: true,
        }),
        customerId: this.$ruleUtil.simple({
          fieldName: "客户",
          handleType: "选择",
          required: true,
        }),
        customerName: this.$ruleUtil.simple({
          fieldName: "联系人姓名",
          required: true,
          max: 50,
        }),
        customerPhoneNumber: this.$ruleUtil.simple({
          fieldName: "联系方式",
          required: true,
          max: 20,
        }),
        customerAddress: this.$ruleUtil.simple({
          fieldName: "联系地址",
          required: true,
          max: 20,
        }),
        relatedSaleOrderHeadId: this.$ruleUtil.simple({
          fieldName: "退货销售单",
          handleType: "选择",
          required: true,
        }),
        saleUserIdList: this.$ruleUtil.array("业务员", "选择", 1),
        totalQuantity: this.$ruleUtil.quantity(
          "退货商品",
          this.quantityMinLimit,
          1000
        ),
      };
      return res;
    },
  },
  data() {
    return {
      orderConfig: {
        needApproval: true,
        editCustomer: false,
        selectSaleUser: false,
      },

      // 预选的单据信息
      preInfo: {
        saleOrderId: null,
        saleOrder: {},
      },

      orderDatePickerShow: false,
      editItemPopupShow: false,
      editItem: {},

      id: null,
      headInfo: {
        orderApprovalStatusEnum: {},
        orderDate: null,
        customerId: null,
        customerName: null,
        customerPhoneNumber: null,
        customerAddress: "",
        relatedSaleOrderHeadId: null,
        shippedMark: true,
        collectedMark: true,
        saleUserIdList: [],
        commodityBuyingTotalAmount: "0.00",
        orderAmount: "0.00",
        totalQuantity: 0,
        remark: "",
      },
      itemList: [],
      customer: {},
      saleUserList: [],
      relatedSaleOrderHead: {},

      saleOrderSelectDialogShow: false,
      saleOrderItemSelectDialogShow: false,

      itemQuantityKey: "null",

      quantityMinLimit: 0.001,
    };
  },
  methods: {
    // 业务员
    addSaleUser(list) {
      this.saleUserList = this.saleUserList.concat(list);
    },
    cancelSaleUser(list) {
      let cancelIdList = list.map((d) => d.id);
      this.saleUserList = this.saleUserList.filter(
        (d) => !cancelIdList.some((f) => f == d.id)
      );
    },
    async handlePreInfo() {
      if (this.preInfo.saleOrderId) {
        let getOrderRes = await this.$api.saleOrder_findVoById(
          this.preInfo.saleOrderId
        );
        if (getOrderRes && getOrderRes.success) {
          let saleOrderVo = getOrderRes.data;
          this.preInfo.saleOrder = saleOrderVo;
          this.headInfo = {
            ...this.headInfo,
            customerId: saleOrderVo.headVo.customer.id,
            customerName: saleOrderVo.headVo.customerName,
            customerPhoneNumber: saleOrderVo.headVo.customerPhoneNumber,
            customerAddress: saleOrderVo.hheadVoead.customerAddress,
            relatedSaleOrderHeadId: saleOrderVo.headVo.id,
            saleUserIdList: saleOrderVo.headVo.saleUserList.map(
              (d) => d.userId
            ),
          };
          this.customer = saleOrderVo.headVo.customer;
          this.relatedSaleOrderHead = saleOrderVo.headVo;
          this.saleUserList = saleOrderVo.headVo.saleUserList.map(
            (d) => d.user
          );
          this.$message({
            message: "已初始化部分单据信息，请继续完善其他信息",
            type: "success",
          });
        } else {
          this.$showModal({
            title: "操作提醒",
            content: "获取销售单信息失败",
            confirmText: "返回",
            showCancel: false,
            allowBackPress: false,
            success(res) {
              uni.navigateBack();
            },
          });
          return;
        }
      }
    },
    async initOrderData() {
      let userInfo = await this.$storageUtil.getUserInfo();
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.headInfo.saleUserIdList = [userInfo.id];
      this.saleUserList = [userInfo];
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:SaleReturnOrder:NeedApproval",
        "Order:SaleReturnOrder:SelectSaleUser",
        "Order:SaleReturnOrder:EditCustomer",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleReturnOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }
        let selectSaleUserIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleReturnOrder:SelectSaleUser"
        );
        if (
          selectSaleUserIndex > -1 &&
          res.data[selectSaleUserIndex].value == "true"
        ) {
          this.orderConfig.selectSaleUser = true;
        }
        let editCustomerIndex = res.data.findIndex(
          (d) => d.code == "Order:SaleReturnOrder:EditCustomer"
        );
        if (
          editCustomerIndex > -1 &&
          res.data[editCustomerIndex].value == "true"
        ) {
          this.orderConfig.editCustomer = true;
        }
      }
    },
    // 编辑item
    editItemClick(item) {
      this.editItemPopupShow = true;
      this.editItem = JSON.parse(JSON.stringify(item));
    },
    changeItemQuantity(index, row, value) {
      let that = this;
      if (value <= 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            that.itemList.splice(index, 1);
            that.selectSaleOrderItem(that.itemList || []);
          })
          .catch(() => {
            row.itemQuantity = that.quantityMinLimit;
            // this.changeItemQuantity(index, row, 1);
            this.itemQuantityKey = Math.random();
          });
      } else {
        let itemAmount = that.$jsTool.multi(
          row.relatedSaleOrderItem.buyingPrice,
          value
        );
        row = {
          ...row,
          itemQuantity: value,
          commodityBuyingTotalAmount: itemAmount,
        };
        let item = {
          ...that.itemList[index],
          itemQuantity: row.itemQuantity,
          commodityBuyingTotalAmount: itemAmount,
        };
        that.itemList.splice(index, 1, item);
        that.selectSaleOrderItem(that.itemList);
      }
    },

    // 获取已选择的文本
    getSelectLabel(type) {
      if (type == "SaleUser") {
        if (this.saleUserList && this.saleUserList.length > 0) {
          return this.saleUserList
            .map((item) => {
              return item.name;
            })
            .join("、");
        }
      } else if (type == "Customer") {
        if (this.customer && this.customer.name) {
          return this.customer.customerNo + " " + this.customer.name;
        }
      } else if (type == "SaleOrder") {
        if (this.relatedSaleOrderHead) {
          return this.relatedSaleOrderHead.orderNo;
        }
      }
      return null;
    },

    // 选择客户
    selectCustomer(item) {
      this.headInfo.customerId = item.id;
      this.headInfo.customerName = item.name;
      this.headInfo.customerPhoneNumber = item.phoneNumber;
      this.headInfo.customerAddress = item.address;
      this.customer = item;
      // 清空已选销售单和商品
      this.headInfo.relatedSaleOrderHeadId = null;
      this.relatedSaleOrderHead = {};
      this.itemList = [];
      this.selectSaleOrderItem([]);
      this.$message({
        message: "已自动更新联系人信息，请选择销售单",
        type: "success",
      });
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("customerId");
      });
      setTimeout(() => {
        this.toSelectSaleOrderPage();
      }, 1000);
    },

    // 选择销售单
    toSelectSaleOrderPage() {
      if (this.preInfo.saleOrderId) {
        this.$message.error("自动创建销售退货单时无法重新选择销售单");
        return;
      }
      let that = this;
      if (!this.customer || !this.customer.id) {
        this.$message.error("请先选择客户");
        return;
      }
      this.saleOrderSelectDialogShow = true;
    },
    selectSaleOrder(item) {
      this.headInfo.relatedSaleOrderHeadId = item.id;
      this.relatedSaleOrderHead = item;
      // 清空已选商品
      this.itemList = [];
      this.selectSaleOrderItem([]);
      let that = this;
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("relatedSaleOrderHeadId");
      });
      this.$confirm(
        "是否使用销售单的联系人信息覆盖此单据的联系人信息？",
        "操作提醒",
        {
          confirmButtonText: "覆盖",
          cancelButtonText: "不覆盖",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        }
      )
        .then(() => {
          that.headInfo.customerName = item.customerName;
          that.headInfo.customerPhoneNumber = item.customerPhoneNumber;
          that.headInfo.customerAddress = item.customerAddress;
          this.$message({
            message: "已将销售单的联系人信息覆盖至此单据，请选择退货商品",
            type: "success",
          });
          setTimeout(() => {
            this.toSelectSaleOrderItemPage();
          }, 1000);
        })
        .catch(() => {
          this.$message({
            message: "请选择退货商品",
            type: "success",
          });
          setTimeout(() => {
            this.toSelectSaleOrderItemPage();
          }, 1000);
        });
    },

    // 选择销售单行项目
    toSelectSaleOrderItemPage() {
      let that = this;
      if (!this.customer || !this.customer.id) {
        this.$message({
          message: "请先选择客户",
          type: "error",
        });
        return;
      }
      if (!this.relatedSaleOrderHead || !this.relatedSaleOrderHead.id) {
        this.$message({
          message: "请先选择销售单",
          type: "error",
        });
        return;
      }
      this.saleOrderSelectDialogShow = false;
      this.saleOrderItemSelectDialogShow = true;
    },
    selectSaleOrderItem(list) {
      this.itemList = list;
      this.headInfo.commodityBuyingTotalAmount = this.$jsTool.sum(
        list.map((d) => d.commodityBuyingTotalAmount)
      );
      this.headInfo.orderAmount = this.headInfo.commodityBuyingTotalAmount;
      this.headInfo.totalQuantity = Number(
        this.$jsTool.sumQuantity(list.map((d) => d.itemQuantity))
      );
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("totalQuantity");
      });
    },

    selectUser(userList = []) {
      this.saleUserList = userList;
      this.headInfo.saleUserIdList = userList.map((item) => item.id);
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("saleUserIdList");
      });
    },

    // 单据日期
    confirmPicker(e, type) {
      if (type == "OrderDate") {
        this.headInfo.orderDate = e.value;
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.validateField("orderDate");
        });
      }
      this.closePicker(type);
    },
    closePicker(type) {
      if (type == "OrderDate") {
        this.orderDatePickerShow = false;
      }
    },
    async getOrderInfo(args) {
      let res = await this.$api.saleReturnOrder_findVoById(this.orderId, {
        showLoading: true,
        loadingParam: {
          target: "#editDialog > *",
          lock: true,
        },
        ...args,
      });
      if (res && res.success) {
        this.headInfo = {
          ...res.data.head,
          saleUserIdList: res.data.head.saleUserList.map((d) => d.userId),
        };
        this.itemList = res.data.itemList;
        this.customer = res.data.head.customer;
        this.saleUserList = res.data.head.saleUserList.map((d) => d.user);
        this.relatedSaleOrderHead = res.data.head.relatedSaleOrderHead;
        if (this.headInfo.orderParam) {
          let orderParam = JSON.parse(this.headInfo.orderParam);
          this.preInfo.saleOrderId = orderParam.preInfo.saleOrderId;
        }
      }
    },

    edit(submit) {
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.saleReturnOrder_updateAndSubmit(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.saleReturnOrder_update(
                {
                  headUpdatePojo: this.headInfo,
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.saleReturnOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.saleReturnOrder_saveIntoDraft(
              {
                headAddNewPojo: this.headInfo,
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style scoped>
</style>>



// WEBPACK FOOTER //
// src/components/order/SaleReturnOrderEditDialog.vue